import * as inEnv from './IN/environment';

export const countryEnvironment = {
	IN: inEnv.environment
};
